export const FILTERED_INDICATORS = [
  'locked',
  'editing',
  'active-workflows',
  'metafill',
  'rules',
  'lock-owner',
  'googledrive',
  'nodeLock',
];

const excelMimeTypes = ['spreadsheetml', 'spreadsheet', 'ms-excel'];
const wordMimeTypes = ['msword', 'wordprocessingml', 'opendocument.text'];
const powerPointMimeTypes = ['powerpoint', 'officedocument.presentation', 'opendocument.presentation'];
const systemMimeTypes = ['csv', 'html', 'xml'];
const textMimeTypes = ['text', 'message/rfc822'];
const archiveMimeTypes = [
  'archive',
  'x-tar',
  'iso9660',
  'bzip2',
  'gzip',
  'compress',
  'x-7z',
  'compressed',
  'diskimage',
  'x-gtar',
  'zip',
];

export const mimeTypeIcon: { [id: string]: string } = {
  Default: 'file',
  Excel: 'file-excel green',
  Word: 'file-word blue',
  'Power-Point': 'file-powerpoint orange',
  System: 'file-code',
  Archive: 'file-archive',
  Image: 'file-image',
  Video: 'file-video',
  Audio: 'file-audio',
  Text: 'file-alt',
  Pdf: 'file-pdf red',
  folder: 'folder',
};

export const getMimeType = (mimetype: string) => {
  if (!mimetype) {
    return 'Default';
  }

  if (excelMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'Excel';
  if (wordMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'Word';
  if (powerPointMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'Power-Point';
  if (systemMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'System';
  if (archiveMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'Archive';
  if (mimetype.includes('image')) return 'Image';
  if (mimetype.includes('video')) return 'Video';
  if (mimetype.includes('audio')) return 'Audio';
  if (textMimeTypes.some(item => mimetype.toLowerCase().includes(item.toLowerCase()))) return 'Text';

  if (mimetype === 'application/pdf') return 'Pdf';

  return 'Default';
};

export const filters = [
  'editingMe',
  'editingOthers',
  'recentlyModified',
  'recentlyAdded',
  'favourites',
];